import "moment/locale/th";

import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
GET_RP_ACTIVITY_ENTRY,
GET_RP_ACTIVITY_EXIT,
GET_RP_SUPPLY_DEMAND_ENTRY,
GET_RP_SUPPLY_DEMAND_EXIT,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { groups } from "../../../../common/data/chat";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SupplyDemandPlan(props) {
  // console.log(props);
  const dispatch = useDispatch();
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const ToNumberFormat = (cell, row, rowIndex) => numberFormat(cell, 0);
  const [columnsSummary, setColumnsSummary] = useState([
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Location",
      headerAlign: "center",
      align: "center",

      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        width: "10%",
        fontWeight: "bold",
      },
      style: {
        width: "10%",
        fontWeight: "bold",
        fontSize: "1vw",
      },
      // sort: true,
    },
    {
      dataField: "ACTIVITY_PLAN_ENTRY",
      text: "Entry(Weekly Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        // console.log(row)
        let className = "";
        if (row.ENTRY_groups != null)
          className = `ENTRY_WEEKLY_PLAN ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        fontWeight: "bold",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
    {
      dataField: "ACTIVITY_ACTUAL_ENTRY",
      text: "Entry(Daily Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `ENTRY_DAILY_PLAN ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        fontWeight: "bold",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },

    {
      dataField: "ACTIVITY_PLAN_EXIT",
      text: "Exit(Weekly Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `EXIT_WEEKLY_PLAN ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        fontWeight: "bold",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
    {
      dataField: "ACTIVITY_ACTUAL_EXIT",
      text: "Exit(Daily Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `EXIT_DAILY_PLAN ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        fontWeight: "bold",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },

  ]);


  const rowStyleSummary = (row, rowIndex) => {
    const style = {};
    if (rowIndex == props.modelDeviceList.length - 1) {
      style.backgroundColor = "#466597"; //rgb(50, 57, 78)
      style.color = "#FFFFFF";
    } else {
      style.color = "#FFFFFF";
    }
    style.fontSize= "1vw";
    style.height = "10vh";
    style.verticalAlign='middle'
    return style;
  };

  //headerColumn
  useEffect(() => {
    let classMerged = [];
    function mergeCell(index) {
      if (classMerged.indexOf($(this).attr("class")) == -1) {
        let [field, group, rowspan] = $(this).attr("class")?.split(/\s+/);
        $(this).attr("rowspan", rowspan.replaceAll("rowspan", ""));
        $(`.${field}.${group}.${rowspan}`).not(":first").hide();
      }
      classMerged.push($(this).attr("class"));
    }
    $(".ENTRY_WEEKLY_PLAN").each(mergeCell);
    $(".ENTRY_DAILY_PLAN").each(mergeCell);
    $(".EXIT_WEEKLY_PLAN").each(mergeCell);
    $(".EXIT_DAILY_PLAN").each(mergeCell);

  }, [props.modelDeviceList]);





  const addHeaderTable = () => {
    let prevHeader1 = document.getElementById("supply-demand-plan-header1");
    prevHeader1 && prevHeader1.remove();
    let prevHeader2 = document.getElementById("supply-demand-plan-header2");
    prevHeader2 && prevHeader2.remove();
    let prevFooter = document.getElementById("supply-demand-plan-footer");
    prevFooter && prevFooter.remove();
    let thead = document
      .getElementById("supply-demand-plan-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="supply-demand-plan-header1" colspan="' +
      3 +
      '" style="text-align:center;background-color:#556ee678;color:#7AE3F7">Today Supply & Demand Plan</th><th id="supply-demand-plan-header2" colspan="' +
      2 +
      '" style="text-align:center;background-color:#5868b785;color:#7AE3F7;text-align:right">Unit: MMscfd</th>';
    thead.prepend(tr);

    let table = document
      .getElementById("supply-demand-plan-table")

    // let tfooter = document.createElement("tfooter");
    // tfooter.innerHTML =
    //     '<tfooter id="supply-demand-plan-footer"><tr><td colspan="3" style="text-align:center;background-color:#556ee678;color:#7AE3F7">Khanom ( Of ปริมาณรวมอยู่ในตะวันออก )</td><td style="text-align:center;background-color:#556ee678;color:#7AE3F7">0</td><td style="text-align:center;background-color:#556ee678;color:#7AE3F7">0</td></tr></tfooter>';
    //     table.appendChild(tfooter);
  };






  return (


    <BootstrapTable
      id="supply-demand-plan-table"
      wrapperClasses="table-on-scroll"
      keyField="SUPPLYDEMAND_NAME"
      data={props.modelDeviceList}
      columns={columnsSummary}
      rowStyle={rowStyleSummary}
      // rowClasses={rowClass}
      headerClasses="header-style"
    />

  );
}

SupplyDemandPlan.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  modelDeviceList: PropTypes.any,
};

export default SupplyDemandPlan;
